import { enUS, enGB, fr, de, es } from "date-fns/locale";
import type { Locale } from "date-fns";

const dateLocaleMap: Record<string, Locale> = {
  "en-us": enUS,
  "en-gb": enGB,
  "fr-fr": fr,
  "de-de": de,
  "es-es": es,
};

export function getDateFnsLocale(userLanguage: string | null): Locale {
  const localeKey = (userLanguage || "en-us").toLowerCase();
  return dateLocaleMap[localeKey] || enUS;
}

export function getHighchartsLangConfig(userLanguage: string | null) {
  const locale = getDateFnsLocale(userLanguage);

  const months: string[] = [];
  const shortMonths: string[] = [];
  const weekdays: string[] = [];

  for (let i = 0; i < 12; i++) {
    months.push(locale.localize?.month(i) || "");
    shortMonths.push(locale.localize?.month(i, { width: "abbreviated" }) || "");
  }

  for (let i = 0; i < 7; i++) {
    weekdays.push(locale.localize?.day(i) || "");
  }

  return {
    months,
    shortMonths,
    weekdays,
  };
}
